import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { HeaderComponent } from '../shared/components/header/header';
import { LoaderComponent } from '../shared/components/loader/loader';

const LANGUAGE_STORAGE_KEY = 'languageKey';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TranslocoModule, HeaderComponent, LoaderComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly transloco = inject(TranslocoService);

  readonly pageBackground = signal(this.getLeafBackground());

  constructor() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.pageBackground.set(this.getLeafBackground());
        document.querySelector('.router-content')?.scrollTo({ top: 0 });
      });

    this.restoreLanguageFromStorage();
  }

  private restoreLanguageFromStorage(): void {
    const lang = sessionStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (!lang) {
      return;
    }

    const availableLangs = this.transloco.getAvailableLangs().map(l => (typeof l === 'string' ? l : l.id));
    if (availableLangs.includes(lang)) {
      this.transloco.setActiveLang(lang);
    }
  }

  private getLeafBackground(): string {
    let route = this.activatedRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.snapshot.data['background'] ?? 'white';
  }
}
